export interface CategoryBadges {
  categoryTitle: string;
  badges: Badge[];
}

export type Badge = {
  id: number;
  title: string;
  description: string;
  unitType: string;
  timesWon: number;
  timesWonLabel: string;
  progress: number;
  goal: number;
};

export enum BadgeCategory {
  FIRST_STEPS = 0,
  MAKING_PROGRESS = 1,
  CRONO = 2,
  SOCIAL = 3,
  GOAL_HUNTERS = 4,
  HALL_OF_FAME = 5,
  CHALLENGES = 6,
}

export enum RankingBadge {
  /*
   ** Badges that depend on the ranking
   ** They shouldn't show when the ranking is disabled */
  GOLD = 22,
  SILVER = 23,
  BRONZE = 24,
}

export enum LeesBadgeNotToShow {
  SPEEDILY = 4,
  POLYGLOT = 5,
  EXPLORER = 6,
  SPECIALIST = 7,
  PROFESSIONAL = 16,
  OUT_OF_THE_WORLD = 27,
}
